import { useT } from "../../i18n";
import Layout from "../../components/Layout";
import { Paper, Typography } from "@mui/material";
import BaustellenDataTable from "../../components/baustellen/BaustellenDataTable";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import Guard from "../../components/Guard";

export default function BaustellenListe() {
  const { t } = useT("customer");
  const limit = parseInt(localStorage.getItem("baustellenLimit") ?? "25", 10);
  return (
    <Layout title={t("construction-site_other")} showTitleInNav={false}>
      <Guard
        permission={"baustelle:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">{t("construction-site_other")}</Typography>
          <BaustellenDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
